module.exports = __webpack_public_path__ + "img/image_main.f404b3eb.jpg";